import { Injectable, NgZone } from '@angular/core';
import { AppService } from '../shared/service/AppService.class';
import { HttpClient } from '@angular/common/http';
import { Calendar, GoogleLogin } from './model/model.class';
import 'rxjs/add/operator/map';
import GoogleUser = gapi.auth2.GoogleUser;
import GoogleAuth = gapi.auth2.GoogleAuth;
import { GoogleAuthService } from 'ng-gapi';
import * as _ from "lodash";
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable()
export class CalendarService extends AppService<Calendar>{
  constructor(protected http:HttpClient) {
    super(http);
    this.appmod="custom/agentgoogleevent";
  }

    getCalendarList():Observable<any>
    {
        let tmp = this.appmod;
        this.appmod="calendarlist";   
        let cdlist = this.getService();
        this.appmod=tmp;
        return cdlist;
    }
    getPermissionOfCalendar(data):Observable<any>{
        let tmp = this.appmod;
        this.appmod="custom/accesstocalendar";   
        console.log('check service ',data);
        let response = this.manageService(data);
        this.appmod=tmp;
        return response;
    }
    
    
    getAuthToken():Observable<any>
    {
        let tmp = this.appmod;
        this.appmod="agentauthtoken";   
        let auth = this.getService();
        this.appmod=tmp;
        return auth;       
    }  

    updateMyCalender(cndata:any, type:string):Observable<any>
    {
        let tmp = this.appmod;
        this.appmod="mycalender";   
        let cdlist = this.custupdateService(cndata, type);
        this.appmod=tmp;
        return cdlist;
    }

    GetTimezoneList():Observable<any>
    {
        let tmp = this.appmod;
        this.appmod="mortgage";   
        let cdlist = this.getService("timezonelist");
        this.appmod=tmp;
        return cdlist;
    }
   
}

@Injectable()
export class GoogleLoginService extends AppService<GoogleLogin>{
    public static readonly SESSION_STORAGE_KEY: string = "accessToken";
    private user: GoogleUser = undefined;

    constructor(private googleAuthService: GoogleAuthService, private ngZone: NgZone, protected http:HttpClient, protected router:Router) {
        super(http);
        this.appmod="agentauthtoken";
    }

    saveAuthToken(authdata:any):Observable<any>
    {
        let tmp = this.appmod;
        this.appmod="custom/agentauthtoken";   
        let auth = this.saveService(authdata);
        this.appmod=tmp;
        return auth;       
    }
    
    public setUser(user: GoogleUser): void {
        this.user = user;
    }

    public getCurrentUser(): GoogleUser {
        return this.user;
    }

    public getToken(): string {
        let token: string = sessionStorage.getItem(GoogleLoginService.SESSION_STORAGE_KEY);
        if (!token) {
            throw new Error("no token set , authentication required");
        }
        return sessionStorage.getItem(GoogleLoginService.SESSION_STORAGE_KEY);
    }

    public signIn() {
        this.googleAuthService.getAuth().subscribe((auth) => {
            auth.grantOfflineAccess().then(res => this.signInSuccessHandler(res), err => this.signInErrorHandler(err));
        });
    }

   /*  public signIn() {
        this.googleAuthService.getAuth().subscribe((auth) => {
            auth.signIn().then(res => this.signInSuccessHandler(res), err => this.signInErrorHandler(err));
        });
    } */

    //TODO: Rework
    public signOut(): void {
        this.googleAuthService.getAuth().subscribe((auth) => {
            try {
                auth.signOut();
            } catch (e) {
                console.error(e);
            }
            sessionStorage.removeItem(GoogleLoginService.SESSION_STORAGE_KEY)
        });
    }

    public isUserSignedIn(): boolean {
        return !_.isEmpty(sessionStorage.getItem(GoogleLoginService.SESSION_STORAGE_KEY));
    }

    private signInSuccessHandler(res: any) {
        console.log("token get");
        console.log(res);
        let agent_accesstoken = res.code;
        this.saveAuthToken(JSON.stringify({access_token: agent_accesstoken})).subscribe(res=>{
        //this.http.post<any>(APIURL+"custom/agentauthtoken", {"data":{access_token: agent_accesstoken}},{ headers: {"Content-Type": "application/json"}, params: {"data": agent_accesstoken} }).subscribe(res=>{
            console.log(res);
            console.log("redirect to google login");
            //this.router.navigate ( [ '/calendar/googlelogin' ] );
            window.location.reload();
        });
        // console.log("Current URI : "+APIURL+"custom/agentauthtoken");
        // let agent_accesstoken:gapi.auth2.AuthResponse=res.getAuthResponse();
        // console.log(agent_accesstoken);
        // //let agent_accesstoken='4/SQAMyzAntRWfOoV4AHOyTbOkwynZ_rBxpN7vKbVWMrLtIHvhpbZTz50';
        // this.http.post<any>(APIURL+"custom/agentauthtoken", {"data":{access_token: JSON.stringify(agent_accesstoken)}},{ headers: {"Content-Type": "application/json"}, params: {"data": JSON.stringify(agent_accesstoken)} }).subscribe(res=>{
        //     console.log(res);
        //     this.router.navigate ( [ '/calendar' ] );
        // });
        // this.ngZone.run(() => {
        //     this.user = res;
        //     sessionStorage.setItem(
        //         GoogleLoginService.SESSION_STORAGE_KEY, res.getAuthResponse().access_token
        //     );
        // });
    }

    private signInErrorHandler(err) {
        console.warn(err);
        console.log(err);
    }
}